var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3DotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_3dot-icon",
    "data-name": "3dot-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 22,
    viewBox: "0 0 4 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#307ad7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 9)",
    fill: "#307ad7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 18)",
    fill: "#307ad7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DotIcon);
export default __webpack_public_path__ + "static/media/3dot-icon.ff775c7fc0d399c380b8e99b9d609db8.svg";
export { ForwardRef as ReactComponent };